import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cookies-msg',
  templateUrl: './cookies-msg.component.html',
  styleUrls: ['./cookies-msg.component.scss']
})
export class CookiesMsgComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    if (!this.cookiesAccepted()) {
      this.showModal();
    }
  }

  changeAccept(accept): void {
    if (accept) {
      this.setCookie('eu_cookie_consent', 'accepted');
    }
    this.closeModal();
  }

  cookiesAccepted(): boolean {
    return this.getCookie('eu_cookie_consent');
  }

  setCookie(cname, cvalue): void {
    document.cookie = cname + '=' + cvalue + ';path=/';
  }

  deleteCookie(cname): void {
    document.cookie = cname + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }

  getCookie(cname): boolean {
    const name = cname + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return true;
        }
    }
    return false;
  }

  showModal(): void {
    document.getElementById('myModal').style.display = 'block';
  }

  closeModal(): void {
    document.getElementById('myModal').style.display = 'none';
  }

}
